module.exports = flarum.core.compat['components/HeaderSecondary'];